export default __webpack_public_path__ + "static/media/img-1.45831b6f.png";